export const OfficeFluidContainerPackageName = '@ms/office-fluid-container';
export const OneNoteMeetingPackageName = '@ms/onenote-meetings';

export const OfficeFluidContainerJsCdnDogfood = 'https://officefluidprodprvversionedcdn.azureedge.net';
export const OfficeFluidContainerJsCdnProd = 'https://officefluidprodversionedcdn.azureedge.net';

export const OfficeFluidContainerManifestUrlDogfood = 'https://officefluidprodprvverizoncdn.azureedge.net';
export const OfficeFluidContainerManifestUrlProd = 'https://officefluidprodverizoncdn.azureedge.net';
